module.exports = __webpack_public_path__ + "static/img/xmsb.325e5aa2.png";